import { ISchema } from '@formily/react'
import {
  DataSourceSetter,
} from '@/pages/MainPage/frames/Formily/src/setters'

export const CascadePicker: ISchema = {
  type: 'object',
  properties: {
    options: {
      title: '配置可选项',
      "x-decorator": 'FormItem',
      "x-component": DataSourceSetter
    },
    clearable: {
      type: 'boolean',
      'x-decorator': 'FormItem',
      'x-component': 'Switch',
    },
    placeholder: {
      type: 'string',
      'x-decorator': 'FormItem',
      'x-component': 'Input',
    },
  },
}

